import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { Generator } from '../generator';
import { TopicWidgetProperties } from 'book-widgets/interfaces';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const Hero = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, compconn = false, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);

	return v('section', { classes: [themeCss.hero, ...additionalClasses] }, [
		w(Generator, { skipTitle: false, insection: true, compconn, topic: topicdata as any })
	]);
});
